import Seo from "components/Seo";
import { useLocation } from "react-router-dom";

const PRIVATE_PREFIXES = ["/admin", "/promoter", "/pages/Dashboard"];
const AUTH_PREFIXES = ["/sign-in", "/sign-up", "/forgot-password", "/reset-password"];

function RouteSeo() {
  const { pathname } = useLocation();

  const isPrivate = PRIVATE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
  const isAuth = AUTH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
  const isGalleryImage = pathname.startsWith("/event-image/");

  if (isPrivate || isAuth || isGalleryImage) {
    return (
      <Seo
        title="HanyeLeo"
        description="HanyeLeo"
        canonicalPath={pathname}
        robots="noindex,nofollow"
      />
    );
  }

  return null;
}

export default RouteSeo;
